import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
//Components
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';

export function ErrorBanner({ error, closeBanner }: { error: string; closeBanner: () => void }) {
    const { t } = useTranslation('integrations');
    return (
        <CompoundBanner type="error">
            <CompoundBanner.Icon icon="disconnect" />
            <CompoundBanner.Content title={t('errors:error')}>
                <span>{error}</span>
            </CompoundBanner.Content>
            <CompoundBanner.Close onClose={closeBanner} />
        </CompoundBanner>
    );
}
